import { render, staticRenderFns } from "./waveOptions.vue?vue&type=template&id=48c09183&scoped=true&lang=true&"
import script from "./waveOptions.vue?vue&type=script&lang=js&"
export * from "./waveOptions.vue?vue&type=script&lang=js&"
import style0 from "./waveOptions.vue?vue&type=style&index=0&id=48c09183&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c09183",
  null
  
)

export default component.exports